import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { primarycolor } from "../../utils/colors";
import { useNavigate } from "react-router-dom";
import { Shuffle } from "../../utils/functions";
import img from '../../assets/product-placeholder.png';
import { imageurl, imgCheck } from "../../utils/fn";



const Onofferslider = ({ products, sitename }) => {
    const navigate = useNavigate()
    const [arraytoshow, setarraytoshow] = useState([]);
    const filtered = Shuffle(products).slice(0, products?.length / 3)
    //view product
    function viewProduct(data) {
        navigate('/product/' + data?.itemURL, {
            state: { product: data }
        });
    }

    useEffect(() => {
        const productslength = products.length;

        const intervalId = setInterval(() => {
            setarraytoshow((prevArray) => {
                if (prevArray.length > 0) {
                    const inPlayIndex = products.findIndex((obj) => obj?.itemURL === prevArray[0]?.itemURL);

                    if (inPlayIndex === productslength - 1) {
                        return [products[0]];
                    } else {
                        return [products[inPlayIndex + 1]];
                    }
                } else {
                    return [products[0]];
                }
            });
        }, 3000);

        // Cleanup the interval on component unmount
        return () => clearInterval(intervalId);

    }, [products]); // Include products as a dependency to re-run the effect when products change







    return (
        <Swiper
            slidesPerView={1}
            spaceBetween={5}
            slidesPerGroup={1}
            autoplay={{
                delay: 2000,
                pauseOnMouseEnter: false,
                disableOnInteraction: false
            }}
            loop={false}
            loopFillGroupWithBlank={true}
            shortSwipes={false}
            modules={[Pagination, Navigation]}
            color={primarycolor}
            pagination={{
                clickable: true
            }}
            navigation={false}
            // navigation={{
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // }}
            style={{
                "--swiper-pagination-color": "#ffff",
                "--swiper-navigation-color": primarycolor,
                "--swiper-navigation-size": "30px",
            }}
        >
            {Array.isArray(arraytoshow) && arraytoshow.length > 0 && arraytoshow.map((val, key) => {
                let image_url
                const savingpercentage = val?.amount_value ? Math.round(((parseFloat(val?.amount_value) - parseFloat(val.promotion_price)) / parseInt(val.amount_value)) * 100) : 0
                Array.isArray(val?.src) && imgCheck(val?.src[0], img).then((src) => { image_url = src });

                return (
                    <SwiperSlide key={key} >
                        <div className="banner2" >
                            <div className="wrapofferproduct">
                                <div className="wrapchildproduct">
                                    <div className="offerheading">{sitename} provides a range of enticing offers <br />
                                        ensuring customers have access to competitive deals on <br />
                                        {val?.group_name}</div>
                                    <h4 className="wrapchildproductname">{val?.item_name}</h4>
                                    <div className="offerbox" onClick={() => viewProduct(val)}>
                                        <h5>UP TO</h5>
                                        <h4> - {savingpercentage}% OFF</h4>
                                    </div>
                                </div>
                                <div className="offerproductimage">
                                    <img onClick={() => viewProduct(val)} src={imageurl(image_url) || img} />
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                )
            })
            }
            {/* <div className="swiper-button-prev" />
            <div className="swiper-button-next" /> */}
        </Swiper>
    )
}

export default Onofferslider